import { render, staticRenderFns } from "./feedback-list.vue?vue&type=template&id=81bf1020&"
import script from "./feedback-list.vue?vue&type=script&lang=js&"
export * from "./feedback-list.vue?vue&type=script&lang=js&"
import style0 from "./feedback-list.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports